import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, LogOut } from 'lucide-react';
import './company-setup.css';

export default function CompanySetupLayout({ children, companyName, onLogout }) {
    return <div className="company-setup">
        <header className="company-setup-header">
            <Link to="/select-company" className="company-setup-brand" aria-label="LedgerLoop – dina företag">LedgerLoop<span>AI</span></Link>
            <nav aria-label="Kontohantering">
                <Link to="/select-company"><ArrowLeft size={16} aria-hidden="true" /> Dina företag</Link>
                <a href="mailto:hello@ledgerloop.ai">Behöver du hjälp?</a>
                {onLogout && <button type="button" onClick={onLogout}><LogOut size={16} aria-hidden="true" /> Logga ut</button>}
            </nav>
        </header>
        <main className="company-setup-main">
            {companyName && <p className="company-setup-company">{companyName}</p>}
            {children}
        </main>
        <footer className="company-setup-footer">
            <span>LedgerLoop AB</span>
            <a href="https://www.ledgerloop.ai/legal/allmanna-villkor/" target="_blank" rel="noreferrer">Allmänna villkor</a>
            <a href="https://www.ledgerloop.ai/legal/integritetspolicy/" target="_blank" rel="noreferrer">Integritetspolicy</a>
        </footer>
    </div>;
}
